export const POSTHOG_UI_HOST = 'https://eu.posthog.com';

const ASSET_PATH_PREFIXES = ['/static/', '/array/'] as const;

export function getPostHogIngestTargetHost(pathname: string): string {
  const isAsset = ASSET_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
  return isAsset ? 'eu-assets.i.posthog.com' : 'eu.i.posthog.com';
}

export function getPostHogApiHost(explicitHost?: string, apiBase?: string): string {
  if (explicitHost) return explicitHost;
  if (apiBase?.startsWith('http')) {
    return `${apiBase.replace(/\/api\/?$/, '')}/ingest`;
  }
  return '/ingest';
}
